var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{on:{"enter":_vm.onStartLoading,"leave":_vm.onLoaded,"after-leave":_vm.aniEnded}},[(_vm.show)?_c('div',{ref:"mainbody",staticClass:"opening-animation-container"},[_c('div',{staticClass:"opening-main-container"},[_c('div',{staticClass:"loading-logo"}),_c('div',{staticClass:"loading-bar"})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }